import * as actions from "./oneDaySale.types";


interface IState {
  oneDaySaleAppraisal: any;
  selectedOneDayAppraisal: any;
  oneDaySaleDate: any;
  oneDaySaleWorkbook: any;
  selectedOneDaySaleTradeIn: any;
  error: null | object;
  loading:boolean;
  appraisalOnedayTableList: any;
  isShowWarnig: any;
  onedaysaleHasChange: any;
  menuToRoute : any;

}

const initialState: IState = {
  oneDaySaleAppraisal:[],
  selectedOneDayAppraisal: null,
  oneDaySaleDate: [],
  selectedOneDaySaleTradeIn:null,
  oneDaySaleWorkbook:[],
  error: null,
  loading: false,
  appraisalOnedayTableList:[],
  isShowWarnig: false,
  onedaysaleHasChange: false,
  menuToRoute:''


};

export const OneDaySaleReducer = (
  state: IState = initialState,
  action: actions.OneDaySaleDateActions
) => {
  switch (action.type) {
    case actions.GET_ONE_DAY_SALE_WORKBOOK_PENDING:
      return {
        ...state,
        error: null,
      };
      
    case actions.GET_ONE_DAY_SALE_WORKBOOK_REJECTED:
      return { 
      ...state, 
      error: action.payload 
      };

    case actions.GET_ONE_DAY_SALE_WORKBOOK_RESOLVED:  
    return {
      ...state,
      loading: false,
      error: null,
      oneDaySaleWorkbook: action.payload
    };
    case actions.GET_ONE_DAY_SALE_DATE_PENDING:
      return {
        ...state,
        error: null,
      };
      
    case actions.GET_ONE_DAY_SALE_DATE_REJECTED:
      return { 
      ...state, 
      error: action.payload 
      };

    case actions.GET_ONE_DAY_SALE_DATE_RESOLVED:  
    return {
      ...state,
      loading: false,
      error: null,
      oneDaySaleDate: action.payload
    };
    case actions.HANDLE_SELECTED_ONEDAYSALE_TRADEIN:  
    return {
      ...state,
      loading: false,
      error: null,
      selectedOneDaySaleTradeIn: action.payload
    };
        
    case actions.GET_ONE_DAY_APPRAISAL_TABLE_LIST_PENDING:
        return {
            ...state,
            loading: false,
            appraisalOnedayTableList: null,
            error:null
        };

    case actions.GET_ONE_DAY_APPRAISAL_TABLE_LIST_RESOLVED: 
       return {
         ...state,
         loading: false,
         appraisalOnedayTableList: action.payload
       };

    case actions.GET_ONE_DAY_APPRAISAL_TABLE_LIST_REJECTED:
        return {
            ...state,
            loading: false,
            error: action.payload
        };
    case actions.HANDLE_SHOW_ONEDAY_SALE_WARNING_RESOLVED:
          return {
              ...state,
              onedaysaleHasChange: action.payload.formData.hasChange,
              isShowWarnig: action.payload.formData.showWarning ,
              menuToRoute :action.payload.formData.isMenu ,
          };         

    default:
      return state;
  }
};
